/**
 * Generated API client functions for checkout_v2026_04
 *
 * DO NOT EDIT THIS FILE DIRECTLY
 * This file is auto-generated. To update:
 * 1. Update the OpenAPI spec file
 * 2. Run: pnpm generate
 */

import type { FetchClient } from "../lib/fetch-client";
import type { operations } from "../generated/checkout-v2026-04";

// ============================================================================
// carts
// ============================================================================

/**
 * Create a cart
 *
 *
 * @param client - Fetch client instance
 * @param body - body
 */
export async function checkout_v2026_04_create_cart(
  client: FetchClient,
  body: NonNullable<
    operations["checkout_v2026_04_create_cart"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_create_cart"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/carts`, body);
}

/**
 * Show a cart
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 * @param [params] - params
 */
export async function checkout_v2026_04_get_cart(
  client: FetchClient,
  token: string | number,
  params?: operations["checkout_v2026_04_get_cart"]["parameters"]["query"],
): Promise<
  operations["checkout_v2026_04_get_cart"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/carts/${token}`, params);
}

/**
 * Update cart attributes
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 * @param body - body
 */
export async function checkout_v2026_04_update_cart(
  client: FetchClient,
  token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_update_cart"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_update_cart"]["responses"][200]["content"]["application/json"]
> {
  return client.patch(`/api/checkout/v2026-04/carts/${token}`, body);
}

/**
 * Set cart address
 * Sets the shipping/billing address. Triggers full recalculation (tax, shipping, totals) and fires webhook.
 *
 * @param client - Fetch client instance
 * @param token - token
 * @param body - body
 */
export async function checkout_v2026_04_update_cart_address(
  client: FetchClient,
  token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_update_cart_address"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_update_cart_address"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/carts/${token}/address`, body);
}

/**
 * Complete checkout
 * Completes the checkout process. Supports Idempotency-Key header.
 *
 * @param client - Fetch client instance
 * @param token - token
 */
export async function checkout_v2026_04_complete_cart(
  client: FetchClient,
  token: string | number,
): Promise<
  operations["checkout_v2026_04_complete_cart"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/carts/${token}/complete`);
}

/**
 * Change cart country
 * Changes the cart's country. This triggers cascading side effects: clears shipping address, removes invalid discounts, recalculates available methods.
 *
 * @param client - Fetch client instance
 * @param token - token
 * @param body - body
 */
export async function checkout_v2026_04_update_cart_country(
  client: FetchClient,
  token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_update_cart_country"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_update_cart_country"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/carts/${token}/country`, body);
}

/**
 * Update cart language
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 * @param body - body
 */
export async function checkout_v2026_04_update_cart_language(
  client: FetchClient,
  token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_update_cart_language"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_update_cart_language"]["responses"][200]["content"]["application/json"]
> {
  return client.patch(`/api/checkout/v2026-04/carts/${token}/language`, body);
}

/**
 * Update cart metadata
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 * @param body - body
 */
export async function checkout_v2026_04_update_cart_metadata(
  client: FetchClient,
  token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_update_cart_metadata"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_update_cart_metadata"]["responses"][200]["content"]["application/json"]
> {
  return client.patch(`/api/checkout/v2026-04/carts/${token}/metadata`, body);
}

/**
 * Recalculate cart totals
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 */
export async function checkout_v2026_04_recalculate_cart(
  client: FetchClient,
  token: string | number,
): Promise<
  operations["checkout_v2026_04_recalculate_cart"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/carts/${token}/recalculate`);
}

/**
 * Select shipping method
 * Selects a shipping method. Idempotent — selecting the same method again is a no-op.
 *
 * @param client - Fetch client instance
 * @param token - token
 * @param body - body
 */
export async function checkout_v2026_04_update_cart_shipping(
  client: FetchClient,
  token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_update_cart_shipping"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_update_cart_shipping"]["responses"][200]["content"]["application/json"]
> {
  return client.put(`/api/checkout/v2026-04/carts/${token}/shipping`, body);
}

/**
 * Sync customer data to cart
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 */
export async function checkout_v2026_04_sync_cart(
  client: FetchClient,
  token: string | number,
): Promise<
  operations["checkout_v2026_04_sync_cart"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/carts/${token}/sync`);
}

/**
 * Set volume rep
 * Sets the volume rep for the cart. Requires authentication. Triggers full recalculation.
 *
 * @param client - Fetch client instance
 * @param token - token
 * @param body - body
 */
export async function checkout_v2026_04_update_cart_volume_rep(
  client: FetchClient,
  token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_update_cart_volume_rep"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_update_cart_volume_rep"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/carts/${token}/volume_rep`, body);
}

// ============================================================================
// cart-auth
// ============================================================================

/**
 * Logout from cart
 *
 *
 * @param client - Fetch client instance
 * @param cart_token - cart_token
 */
export async function checkout_v2026_04_destroy_cart_auth(
  client: FetchClient,
  cart_token: string | number,
): Promise<
  operations["checkout_v2026_04_destroy_cart_auth"]["responses"][200]["content"]["application/json"]
> {
  return client.delete(`/api/checkout/v2026-04/carts/${cart_token}/auth`);
}

/**
 * Send magic link
 *
 *
 * @param client - Fetch client instance
 * @param cart_token - cart_token
 * @param body - body
 */
export async function checkout_v2026_04_send_cart_magic_link(
  client: FetchClient,
  cart_token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_send_cart_magic_link"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_send_cart_magic_link"]["responses"][200]["content"]["application/json"]
> {
  return client.post(
    `/api/checkout/v2026-04/carts/${cart_token}/auth/magic_link`,
    body,
  );
}

/**
 * Get current customer for cart
 *
 *
 * @param client - Fetch client instance
 * @param cart_token - cart_token
 */
export async function checkout_v2026_04_get_cart_auth_me(
  client: FetchClient,
  cart_token: string | number,
): Promise<
  operations["checkout_v2026_04_get_cart_auth_me"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/carts/${cart_token}/auth/me`);
}

/**
 * Verify magic link
 *
 *
 * @param client - Fetch client instance
 * @param cart_token - cart_token
 * @param body - body
 */
export async function checkout_v2026_04_verify_cart_magic_link(
  client: FetchClient,
  cart_token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_verify_cart_magic_link"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_verify_cart_magic_link"]["responses"][200]["content"]["application/json"]
> {
  return client.post(
    `/api/checkout/v2026-04/carts/${cart_token}/auth/verify`,
    body,
  );
}

// ============================================================================
// cart-discount
// ============================================================================

/**
 * Apply discount code
 * Applies a discount code to the cart. Not idempotent — applying the same code twice returns an error.
 *
 * @param client - Fetch client instance
 * @param cart_token - cart_token
 * @param body - body
 */
export async function checkout_v2026_04_apply_cart_discount(
  client: FetchClient,
  cart_token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_apply_cart_discount"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_apply_cart_discount"]["responses"][200]["content"]["application/json"]
> {
  return client.post(
    `/api/checkout/v2026-04/carts/${cart_token}/discount`,
    body,
  );
}

/**
 * Remove discount code
 *
 *
 * @param client - Fetch client instance
 * @param cart_token - cart_token
 * @param body - body
 */
export async function checkout_v2026_04_remove_cart_discount(
  client: FetchClient,
  cart_token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_remove_cart_discount"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_remove_cart_discount"]["responses"][200]["content"]["application/json"]
> {
  return client.delete(`/api/checkout/v2026-04/carts/${cart_token}/discount`, {
    body,
  });
}

/**
 * Apply manual discount (admin only)
 * Creates a one-time manual discount and applies it to the cart. Requires admin authentication (root_or_admin? role). Manual discounts are single-use, require a reason, and are excluded from the promo code management UI.
 *
 * @param client - Fetch client instance
 * @param cart_token - cart_token
 * @param body - body
 */
export async function checkout_v2026_04_apply_manual_discount(
  client: FetchClient,
  cart_token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_apply_manual_discount"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_apply_manual_discount"]["responses"][200]["content"]["application/json"]
> {
  return client.post(
    `/api/checkout/v2026-04/carts/${cart_token}/discount/manual`,
    body,
  );
}

/**
 * List all discounts applied to a cart
 * Returns per-discount detail for all active discounts on a cart, including code, reason, type, defined value, and actual amount applied.
 *
 * @param client - Fetch client instance
 * @param cart_token - cart_token
 */
export async function checkout_v2026_04_list_cart_discounts(
  client: FetchClient,
  cart_token: string | number,
): Promise<
  operations["checkout_v2026_04_list_cart_discounts"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/carts/${cart_token}/discounts`);
}

// ============================================================================
// cart-items
// ============================================================================

/**
 * Add items to cart
 *
 *
 * @param client - Fetch client instance
 * @param cart_token - cart_token
 * @param body - body
 */
export async function checkout_v2026_04_add_cart_items(
  client: FetchClient,
  cart_token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_add_cart_items"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_add_cart_items"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/carts/${cart_token}/items`, body);
}

/**
 * Update a cart item
 *
 *
 * @param client - Fetch client instance
 * @param cart_token - cart_token
 * @param id - id
 * @param body - body
 */
export async function checkout_v2026_04_update_cart_item(
  client: FetchClient,
  cart_token: string | number,
  id: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_update_cart_item"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_update_cart_item"]["responses"][200]["content"]["application/json"]
> {
  return client.patch(
    `/api/checkout/v2026-04/carts/${cart_token}/items/${id}`,
    body,
  );
}

/**
 * Remove a cart item
 *
 *
 * @param client - Fetch client instance
 * @param cart_token - cart_token
 * @param id - id
 */
export async function checkout_v2026_04_delete_cart_item(
  client: FetchClient,
  cart_token: string | number,
  id: string | number,
): Promise<
  operations["checkout_v2026_04_delete_cart_item"]["responses"][200]["content"]["application/json"]
> {
  return client.delete(
    `/api/checkout/v2026-04/carts/${cart_token}/items/${id}`,
  );
}

// ============================================================================
// cart-points
// ============================================================================

/**
 * Apply points
 * Applies loyalty points to the cart. Not idempotent — validates balance and generates idempotency key.
 *
 * @param client - Fetch client instance
 * @param cart_token - cart_token
 * @param body - body
 */
export async function checkout_v2026_04_apply_cart_points(
  client: FetchClient,
  cart_token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_apply_cart_points"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_apply_cart_points"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/carts/${cart_token}/points`, body);
}

/**
 * Remove points
 *
 *
 * @param client - Fetch client instance
 * @param cart_token - cart_token
 */
export async function checkout_v2026_04_remove_cart_points(
  client: FetchClient,
  cart_token: string | number,
): Promise<
  operations["checkout_v2026_04_remove_cart_points"]["responses"][200]["content"]["application/json"]
> {
  return client.delete(`/api/checkout/v2026-04/carts/${cart_token}/points`);
}

// ============================================================================
// customers
// ============================================================================

/**
 * Get customer profile
 * 
 *
 * @param client - Fetch client instance
 
 */
export async function checkout_v2026_04_get_customer_profile(
  client: FetchClient,
): Promise<
  operations["checkout_v2026_04_get_customer_profile"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/customers/me`);
}

/**
 * Update customer profile
 *
 *
 * @param client - Fetch client instance
 * @param body - body
 */
export async function checkout_v2026_04_update_customer_profile(
  client: FetchClient,
  body: NonNullable<
    operations["checkout_v2026_04_update_customer_profile"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_update_customer_profile"]["responses"][200]["content"]["application/json"]
> {
  return client.patch(`/api/checkout/v2026-04/customers/me`, body);
}

/**
 * List customer companies
 * 
 *
 * @param client - Fetch client instance
 
 */
export async function checkout_v2026_04_get_customer_companies(
  client: FetchClient,
): Promise<
  operations["checkout_v2026_04_get_customer_companies"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/customers/me/companies`);
}

// ============================================================================
// customer-addresses
// ============================================================================

/**
 * List customer addresses
 * 
 *
 * @param client - Fetch client instance
 
 */
export async function checkout_v2026_04_list_customer_addresses(
  client: FetchClient,
): Promise<
  operations["checkout_v2026_04_list_customer_addresses"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/customers/me/addresses`);
}

/**
 * Create customer address
 *
 *
 * @param client - Fetch client instance
 * @param body - body
 */
export async function checkout_v2026_04_create_customer_address(
  client: FetchClient,
  body: NonNullable<
    operations["checkout_v2026_04_create_customer_address"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_create_customer_address"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/customers/me/addresses`, body);
}

/**
 * Update customer address
 *
 *
 * @param client - Fetch client instance
 * @param id - id
 * @param body - body
 */
export async function checkout_v2026_04_update_customer_address(
  client: FetchClient,
  id: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_update_customer_address"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_update_customer_address"]["responses"][200]["content"]["application/json"]
> {
  return client.patch(
    `/api/checkout/v2026-04/customers/me/addresses/${id}`,
    body,
  );
}

/**
 * Delete customer address
 *
 *
 * @param client - Fetch client instance
 * @param id - id
 */
export async function checkout_v2026_04_delete_customer_address(
  client: FetchClient,
  id: string | number,
): Promise<
  operations["checkout_v2026_04_delete_customer_address"]["responses"][200]["content"]["application/json"]
> {
  return client.delete(`/api/checkout/v2026-04/customers/me/addresses/${id}`);
}

/**
 * Apply address to subscriptions
 * Apply the specified address to the customer's subscriptions.
Pass `apply_to_all: true` to update all subscriptions, or pass
a `subscription_ids` array to update specific subscriptions only.

 *
 * @param client - Fetch client instance
 * @param id - id
 * @param body - body
 */
export async function checkout_v2026_04_apply_address_to_subscriptions(
  client: FetchClient,
  id: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_apply_address_to_subscriptions"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_apply_address_to_subscriptions"]["responses"][200]["content"]["application/json"]
> {
  return client.post(
    `/api/checkout/v2026-04/customers/me/addresses/${id}/apply_to_subscriptions`,
    body,
  );
}

// ============================================================================
// customer-orders
// ============================================================================

/**
 * List customer orders
 * Returns the authenticated customer's order history with cursor pagination.
 *
 * @param client - Fetch client instance
 * @param [params] - params
 */
export async function checkout_v2026_04_list_customer_orders(
  client: FetchClient,
  params?: operations["checkout_v2026_04_list_customer_orders"]["parameters"]["query"],
): Promise<
  operations["checkout_v2026_04_list_customer_orders"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/customers/me/orders`, params);
}

// ============================================================================
// customer-payment-methods
// ============================================================================

/**
 * List customer payment methods
 * 
 *
 * @param client - Fetch client instance
 
 */
export async function checkout_v2026_04_list_customer_payment_methods(
  client: FetchClient,
): Promise<
  operations["checkout_v2026_04_list_customer_payment_methods"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/customers/me/payment_methods`);
}

/**
 * Create customer payment method
 *
 *
 * @param client - Fetch client instance
 * @param body - body
 */
export async function checkout_v2026_04_create_customer_payment_method(
  client: FetchClient,
  body: NonNullable<
    operations["checkout_v2026_04_create_customer_payment_method"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_create_customer_payment_method"]["responses"][200]["content"]["application/json"]
> {
  return client.post(
    `/api/checkout/v2026-04/customers/me/payment_methods`,
    body,
  );
}

/**
 * Tokenize payment credentials
 * Vaults payment credentials via VGS. Requires a valid customer JWT.
 *
 * @param client - Fetch client instance
 * @param body - body
 */
export async function checkout_v2026_04_tokenize_customer_payment_method(
  client: FetchClient,
  body: NonNullable<
    operations["checkout_v2026_04_tokenize_customer_payment_method"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_tokenize_customer_payment_method"]["responses"][200]["content"]["application/json"]
> {
  return client.post(
    `/api/checkout/v2026-04/customers/me/payment_methods/tokenize`,
    body,
  );
}

/**
 * Update customer payment method
 *
 *
 * @param client - Fetch client instance
 * @param id - id
 * @param body - body
 */
export async function checkout_v2026_04_update_customer_payment_method(
  client: FetchClient,
  id: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_update_customer_payment_method"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_update_customer_payment_method"]["responses"][200]["content"]["application/json"]
> {
  return client.patch(
    `/api/checkout/v2026-04/customers/me/payment_methods/${id}`,
    body,
  );
}

/**
 * Delete customer payment method
 *
 *
 * @param client - Fetch client instance
 * @param id - id
 */
export async function checkout_v2026_04_delete_customer_payment_method(
  client: FetchClient,
  id: string | number,
): Promise<
  operations["checkout_v2026_04_delete_customer_payment_method"]["responses"][200]["content"]["application/json"]
> {
  return client.delete(
    `/api/checkout/v2026-04/customers/me/payment_methods/${id}`,
  );
}

// ============================================================================
// customer-points
// ============================================================================

/**
 * List customer points ledger
 * Returns the authenticated customer's points ledger with cursor pagination.
 *
 * @param client - Fetch client instance
 * @param [params] - params
 */
export async function checkout_v2026_04_list_customer_points(
  client: FetchClient,
  params?: operations["checkout_v2026_04_list_customer_points"]["parameters"]["query"],
): Promise<
  operations["checkout_v2026_04_list_customer_points"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/customers/me/points`, params);
}

// ============================================================================
// enrollments
// ============================================================================

/**
 * Show enrollment
 * Public endpoint — retrieves enrollment form by token.
 *
 * @param client - Fetch client instance
 * @param token - token
 */
export async function checkout_v2026_04_get_enrollment(
  client: FetchClient,
  token: string | number,
): Promise<
  operations["checkout_v2026_04_get_enrollment"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/enrollments/${token}`);
}

/**
 * Submit enrollment field answer
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 * @param field_id - field_id
 * @param body - body
 */
export async function checkout_v2026_04_submit_enrollment_field(
  client: FetchClient,
  token: string | number,
  field_id: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_submit_enrollment_field"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_submit_enrollment_field"]["responses"][200]["content"]["application/json"]
> {
  return client.post(
    `/api/checkout/v2026-04/enrollments/${token}/fields/${field_id}`,
    body,
  );
}

/**
 * Update enrollment field answer
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 * @param field_id - field_id
 * @param body - body
 */
export async function checkout_v2026_04_update_enrollment_field(
  client: FetchClient,
  token: string | number,
  field_id: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_update_enrollment_field"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_update_enrollment_field"]["responses"][200]["content"]["application/json"]
> {
  return client.patch(
    `/api/checkout/v2026-04/enrollments/${token}/fields/${field_id}`,
    body,
  );
}

/**
 * Upload file for enrollment field
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 * @param field_id - field_id
 * @param body - body
 */
export async function checkout_v2026_04_upload_enrollment_field_file(
  client: FetchClient,
  token: string | number,
  field_id: string | number,
  body: FormData,
): Promise<
  operations["checkout_v2026_04_upload_enrollment_field_file"]["responses"][200]["content"]["application/json"]
> {
  return client.requestWithFormData(
    `/api/checkout/v2026-04/enrollments/${token}/fields/${field_id}/upload`,
    body,
  );
}

// ============================================================================
// orders
// ============================================================================

/**
 * Show order
 * Public endpoint — no authentication required. Retrieves an order by token.
 *
 * @param client - Fetch client instance
 * @param token - token
 */
export async function checkout_v2026_04_get_order(
  client: FetchClient,
  token: string | number,
): Promise<
  operations["checkout_v2026_04_get_order"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/orders/${token}`);
}

// ============================================================================
// products
// ============================================================================

/**
 * Query product
 * Uses POST because the request body carries attribution data, locale negotiation, and session context. Public — no auth required.
 *
 * @param client - Fetch client instance
 * @param id - id
 * @param body - body
 */
export async function checkout_v2026_04_query_product(
  client: FetchClient,
  id: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_query_product"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_query_product"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/products/${id}`, body);
}

// ============================================================================
// directory
// ============================================================================

/**
 * List reps
 * Lists reps for the authenticated company. Cursor paginated.
 *
 * @param client - Fetch client instance
 * @param [params] - params
 */
export async function checkout_v2026_04_list_reps(
  client: FetchClient,
  params?: operations["checkout_v2026_04_list_reps"]["parameters"]["query"],
): Promise<
  operations["checkout_v2026_04_list_reps"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/reps`, params);
}

/**
 * List users
 * Lists users for the authenticated company. Cursor paginated.
 *
 * @param client - Fetch client instance
 * @param [params] - params
 */
export async function checkout_v2026_04_list_users(
  client: FetchClient,
  params?: operations["checkout_v2026_04_list_users"]["parameters"]["query"],
): Promise<
  operations["checkout_v2026_04_list_users"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/users`, params);
}

// ============================================================================
// store
// ============================================================================

/**
 * Get address fields for country
 * Public endpoint — returns the address form schema for a given country.
 *
 * @param client - Fetch client instance
 * @param country_code - country_code
 */
export async function checkout_v2026_04_get_store_address_fields(
  client: FetchClient,
  country_code: string | number,
): Promise<
  operations["checkout_v2026_04_get_store_address_fields"]["responses"][200]["content"]["application/json"]
> {
  return client.get(
    `/api/checkout/v2026-04/store/address_fields/${country_code}`,
  );
}

/**
 * Get agreement content
 * Public endpoint — returns agreement content by ID.
 *
 * @param client - Fetch client instance
 * @param id - id
 */
export async function checkout_v2026_04_get_store_agreement(
  client: FetchClient,
  id: string | number,
): Promise<
  operations["checkout_v2026_04_get_store_agreement"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/store/agreements/${id}`);
}

/**
 * Apple Pay domain verification
 * Public endpoint — returns the Apple Pay domain verification file for the given hostname.
 *
 * @param client - Fetch client instance
 * @param hostname - hostname
 */
export async function checkout_v2026_04_get_store_apple_pay_domain(
  client: FetchClient,
  hostname: string | number,
): Promise<
  operations["checkout_v2026_04_get_store_apple_pay_domain"]["responses"][200]["content"]["application/json"]
> {
  return client.get(
    `/api/checkout/v2026-04/store/apple_pay_domain/${hostname}`,
  );
}

/**
 * Get checkout config
 * Returns checkout configuration for the authenticated company. Requires JWT.
 *
 * @param client - Fetch client instance
 
 */
export async function checkout_v2026_04_get_store_config(
  client: FetchClient,
): Promise<
  operations["checkout_v2026_04_get_store_config"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/store/config`);
}

/**
 * List available countries
 * Returns checkout countries for an authenticated customer, or for a guest checkout when cart_token is supplied.
 *
 * @param client - Fetch client instance
 * @param [params] - params
 */
export async function checkout_v2026_04_get_store_countries(
  client: FetchClient,
  params?: operations["checkout_v2026_04_get_store_countries"]["parameters"]["query"],
): Promise<
  operations["checkout_v2026_04_get_store_countries"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/store/countries`, params);
}

/**
 * List drop zones
 * Public endpoint — returns CMS drop zones for the checkout. Requires fluid_shop query param.
 *
 * @param client - Fetch client instance
 * @param params - params
 */
export async function checkout_v2026_04_get_store_drop_zones(
  client: FetchClient,
  params: operations["checkout_v2026_04_get_store_drop_zones"]["parameters"]["query"],
): Promise<
  operations["checkout_v2026_04_get_store_drop_zones"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/store/drop_zones`, params);
}

/**
 * List available languages
 * 
 *
 * @param client - Fetch client instance
 
 */
export async function checkout_v2026_04_get_store_languages(
  client: FetchClient,
): Promise<
  operations["checkout_v2026_04_get_store_languages"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/store/languages`);
}

// ============================================================================
// subscription-bundles
// ============================================================================

/**
 * List subscription bundles
 *
 *
 * @param client - Fetch client instance
 * @param [params] - params
 */
export async function checkout_v2026_04_list_subscription_bundles(
  client: FetchClient,
  params?: operations["checkout_v2026_04_list_subscription_bundles"]["parameters"]["query"],
): Promise<
  operations["checkout_v2026_04_list_subscription_bundles"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/subscription_bundles`, params);
}

/**
 * Create subscription bundle
 *
 *
 * @param client - Fetch client instance
 * @param body - body
 */
export async function checkout_v2026_04_create_subscription_bundle(
  client: FetchClient,
  body: NonNullable<
    operations["checkout_v2026_04_create_subscription_bundle"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_create_subscription_bundle"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/subscription_bundles`, body);
}

// ============================================================================
// subscriptions
// ============================================================================

/**
 * List subscriptions
 * Lists the authenticated customer's subscriptions with cursor pagination. IDOR-safe: scoped to current_customer.
 *
 * @param client - Fetch client instance
 * @param [params] - params
 */
export async function checkout_v2026_04_list_subscriptions(
  client: FetchClient,
  params?: operations["checkout_v2026_04_list_subscriptions"]["parameters"]["query"],
): Promise<
  operations["checkout_v2026_04_list_subscriptions"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/subscriptions`, params);
}

/**
 * Create a subscription
 *
 *
 * @param client - Fetch client instance
 * @param body - body
 */
export async function checkout_v2026_04_create_subscription(
  client: FetchClient,
  body: NonNullable<
    operations["checkout_v2026_04_create_subscription"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_create_subscription"]["responses"][201]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/subscriptions`, body);
}

/**
 * Show subscription
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 */
export async function checkout_v2026_04_get_subscription(
  client: FetchClient,
  token: string | number,
): Promise<
  operations["checkout_v2026_04_get_subscription"]["responses"][200]["content"]["application/json"]
> {
  return client.get(`/api/checkout/v2026-04/subscriptions/${token}`);
}

/**
 * Update subscription
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 * @param body - body
 */
export async function checkout_v2026_04_update_subscription(
  client: FetchClient,
  token: string | number,
  body: NonNullable<
    operations["checkout_v2026_04_update_subscription"]["requestBody"]
  >["content"]["application/json"],
): Promise<
  operations["checkout_v2026_04_update_subscription"]["responses"][200]["content"]["application/json"]
> {
  return client.patch(`/api/checkout/v2026-04/subscriptions/${token}`, body);
}

/**
 * Cancel subscription
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 */
export async function checkout_v2026_04_cancel_subscription(
  client: FetchClient,
  token: string | number,
): Promise<
  operations["checkout_v2026_04_cancel_subscription"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/subscriptions/${token}/cancel`);
}

/**
 * Pause subscription
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 */
export async function checkout_v2026_04_pause_subscription(
  client: FetchClient,
  token: string | number,
): Promise<
  operations["checkout_v2026_04_pause_subscription"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/subscriptions/${token}/pause`);
}

/**
 * Reactivate subscription
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 */
export async function checkout_v2026_04_reactivate_subscription(
  client: FetchClient,
  token: string | number,
): Promise<
  operations["checkout_v2026_04_reactivate_subscription"]["responses"][200]["content"]["application/json"]
> {
  return client.post(
    `/api/checkout/v2026-04/subscriptions/${token}/reactivate`,
  );
}

/**
 * Resume subscription
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 */
export async function checkout_v2026_04_resume_subscription(
  client: FetchClient,
  token: string | number,
): Promise<
  operations["checkout_v2026_04_resume_subscription"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/subscriptions/${token}/resume`);
}

/**
 * Skip subscription
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 */
export async function checkout_v2026_04_skip_subscription(
  client: FetchClient,
  token: string | number,
): Promise<
  operations["checkout_v2026_04_skip_subscription"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/subscriptions/${token}/skip`);
}

/**
 * Undo_skip subscription
 *
 *
 * @param client - Fetch client instance
 * @param token - token
 */
export async function checkout_v2026_04_undo_skip_subscription(
  client: FetchClient,
  token: string | number,
): Promise<
  operations["checkout_v2026_04_undo_skip_subscription"]["responses"][200]["content"]["application/json"]
> {
  return client.post(`/api/checkout/v2026-04/subscriptions/${token}/undo_skip`);
}
